 
import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { SmLogHistorySchema } from '../../../../dashboard/components/utility/schema-defs';
import { getSmLogHistory } from '../../actions/actionType/schedule-maintenance/SmLogHistoryTypes';
import {
  cleargetSmLogHistory,
  getSmLogHistoryFailure,
  getSmLogHistoryStart,
  getSmLogHistorySuccessful
} from '../../actions/sagaActions/schedule-maintenance/SmLogHistorySagaAction';
import {
  GetSmLogHistoryFailurePayload, GetSmLogHistoryRequest
} from '../../actions/types/schedule-maintenance/SmLogHistoryTypes';

/**
 * Call Get metric summary by API
 * @returns api response
 */
export interface IData {
  maintenanceName: string;
  status: string
}

export async function callGetSmLogHistoryApi(data: IData) {
  return apiWrapper.get(
    `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/schedule-maintenance/${data.maintenanceName}/status/${data.status}`
  );
}

export function* getSmLogHistoryApi({ param }: GetSmLogHistoryRequest) {
  yield put(cleargetSmLogHistory());
  yield put(getSmLogHistoryStart());
  try {
    const { responseBody: data, isError, error } = yield call(callGetSmLogHistoryApi, param);

    if (isError) {
      throw error;
    }

    const apiResponse = SmLogHistorySchema.validate(data, {
      abortEarly: true
    });
    if (apiResponse.error) {
      throw new Error('No Response');
    } else {
      yield put(getSmLogHistorySuccessful(data));
    }
  } catch (error: unknown) {
    const obj: GetSmLogHistoryFailurePayload = {
      error: 'Unable to load Audit Data'
    };
    yield put(getSmLogHistoryFailure(obj));
  }
}
/**
 * Saga Effect to consider latest request
 */
export function* GetSmLogHistorySaga() {
  yield takeLatest(getSmLogHistory.FETCH_LOG_HISTORY, getSmLogHistoryApi);
}

export const getSmLogHistorySaga = [fork(GetSmLogHistorySaga)];
